<template>
  <appQuoteNew :propsMode="'new'" :quoteType="'quote'"></appQuoteNew>
</template>
<script>
import appQuoteNew from '../../../components/quote/quoteNew.vue'

export default {
  name: 'QuoteNew',
  components: {
    appQuoteNew
  }
}
</script>
